import React from 'react';

export function DiplomaIcon(props) {
	return (<svg xmlns="http://www.w3.org/2000/svg" width="18" height="16" viewBox="0 0 18 16" fill="none">
		<path d="M3 7.49998L0 5.75L9 0.5L18 5.75V12.125H16.5V6.62502L15 7.49998V12.5085L14.833 12.7148C13.4593 14.4124 11.3563 15.5 9 15.5C6.64363 15.5 4.54072 14.4124 3.16697 12.7148L3 12.5085V7.49998ZM4.5 8.375V11.9688C5.60041 13.2155 7.20834 14 9 14C10.7917 14 12.3996 13.2155 13.5 11.9688V8.375L9 11L4.5 8.375ZM2.97695 5.75L9 9.26345L15.023 5.75L9 2.23656L2.97695 5.75Z" fill="white"/>
		</svg>);
}